module.exports = __webpack_public_path__ + "0ef81f87936fce0ae682d40486acc3a6.MP3";